<script lang="ts" setup>
import { format } from "date-fns";
import { useI18n } from "vue-i18n";

import Week1Img from "@/assets/img/home/weekly-images/1.png?w=712&imagetools";
import Week2Img from "@/assets/img/home/weekly-images/2.png?w=712&imagetools";
import Week3Img from "@/assets/img/home/weekly-images/3.png?w=712&imagetools";
import Week4Img from "@/assets/img/home/weekly-images/4.png?w=712&imagetools";
import Week5Img from "@/assets/img/home/weekly-images/5.png?w=712&imagetools";
import Week6Img from "@/assets/img/home/weekly-images/6.png?w=712&imagetools";
import Week7Img from "@/assets/img/home/weekly-images/7.png?w=712&imagetools";
import Week8Img from "@/assets/img/home/weekly-images/8.png?w=712&imagetools";
import Week9Img from "@/assets/img/home/weekly-images/9.png?w=712&imagetools";
import Week10Img from "@/assets/img/home/weekly-images/10.png?w=712&imagetools";
import Week11Img from "@/assets/img/home/weekly-images/11.png?w=712&imagetools";
import Week12Img from "@/assets/img/home/weekly-images/12.png?w=712&imagetools";
import Week13Img from "@/assets/img/home/weekly-images/13.png?w=712&imagetools";
import Week14Img from "@/assets/img/home/weekly-images/14.png?w=712&imagetools";
import Week15Img from "@/assets/img/home/weekly-images/15.png?w=712&imagetools";
import Week16Img from "@/assets/img/home/weekly-images/16.png?w=712&imagetools";
import Week17Img from "@/assets/img/home/weekly-images/17.png?w=712&imagetools";
import Week18Img from "@/assets/img/home/weekly-images/18.png?w=712&imagetools";
import Week19Img from "@/assets/img/home/weekly-images/19.png?w=712&imagetools";
import Week20Img from "@/assets/img/home/weekly-images/20.png?w=712&imagetools";
import Week21Img from "@/assets/img/home/weekly-images/21.png?w=712&imagetools";
import Week22Img from "@/assets/img/home/weekly-images/22.png?w=712&imagetools";
import Week23Img from "@/assets/img/home/weekly-images/23.png?w=712&imagetools";
import Week24Img from "@/assets/img/home/weekly-images/24.png?w=712&imagetools";
import Week25Img from "@/assets/img/home/weekly-images/25.png?w=712&imagetools";
import Week26Img from "@/assets/img/home/weekly-images/26.png?w=712&imagetools";
import Week27Img from "@/assets/img/home/weekly-images/27.png?w=712&imagetools";
import Week28Img from "@/assets/img/home/weekly-images/28.png?w=712&imagetools";
import Week29Img from "@/assets/img/home/weekly-images/29.png?w=712&imagetools";
import Week30Img from "@/assets/img/home/weekly-images/30.png?w=712&imagetools";
import Week31Img from "@/assets/img/home/weekly-images/31.png?w=712&imagetools";
import Week32Img from "@/assets/img/home/weekly-images/32.png?w=712&imagetools";
import Week33Img from "@/assets/img/home/weekly-images/33.png?w=712&imagetools";
import Week34Img from "@/assets/img/home/weekly-images/34.png?w=712&imagetools";
import Week35Img from "@/assets/img/home/weekly-images/35.png?w=712&imagetools";
import Week36Img from "@/assets/img/home/weekly-images/36.png?w=712&imagetools";
import Week37Img from "@/assets/img/home/weekly-images/37.png?w=712&imagetools";
import Week38Img from "@/assets/img/home/weekly-images/38.png?w=712&imagetools";
import Week39Img from "@/assets/img/home/weekly-images/39.png?w=712&imagetools";
import Week40Img from "@/assets/img/home/weekly-images/40.png?w=712&imagetools";
import Week41Img from "@/assets/img/home/weekly-images/41.png?w=712&imagetools";
import Week42Img from "@/assets/img/home/weekly-images/42.png?w=712&imagetools";
import Week43Img from "@/assets/img/home/weekly-images/43.png?w=712&imagetools";
import Week44Img from "@/assets/img/home/weekly-images/44.png?w=712&imagetools";
import Week45Img from "@/assets/img/home/weekly-images/45.png?w=712&imagetools";
import Week46Img from "@/assets/img/home/weekly-images/46.png?w=712&imagetools";
import Week47Img from "@/assets/img/home/weekly-images/47.png?w=712&imagetools";
import Week48Img from "@/assets/img/home/weekly-images/48.png?w=712&imagetools";
import Week49Img from "@/assets/img/home/weekly-images/49.png?w=712&imagetools";
import Week50Img from "@/assets/img/home/weekly-images/50.png?w=712&imagetools";
import Week51Img from "@/assets/img/home/weekly-images/51.png?w=712&imagetools";
import Week52Img from "@/assets/img/home/weekly-images/52.png?w=712&imagetools";
import Week53Img from "@/assets/img/home/weekly-images/53.png?w=712&imagetools";

const { t } = useI18n();

const wordOfTheWeekMap = {
  1: {
    word: "nytårstorsk",
    img: Week1Img
  },
  2: {
    word: "bommesislag",
    img: Week2Img
  },
  3: {
    word: "bråvallaslag",
    img: Week3Img
  },
  4: {
    word: "bragesnak",
    img: Week4Img
  },
  5: {
    word: "brødflov",
    img: Week5Img
  },
  6: {
    word: "fastelavn",
    img: Week6Img
  },
  7: {
    word: "turtelduer",
    img: Week7Img
  },
  8: {
    word: "das",
    img: Week8Img
  },
  9: {
    word: "dosmerseddel",
    img: Week9Img
  },
  10: {
    word: "rødstrømpe",
    img: Week10Img
  },
  11: {
    word: "florissant",
    img: Week11Img
  },
  12: {
    word: "heksering",
    img: Week12Img
  },
  13: {
    word: "folkemål",
    img: Week13Img
  },
  14: {
    word: "glas",
    img: Week14Img
  },
  15: {
    word: "forvorpen",
    img: Week15Img
  },
  16: {
    word: "grine",
    img: Week16Img
  },
  17: {
    word: "forsoren",
    img: Week17Img
  },
  18: {
    word: "jubelolding",
    img: Week18Img
  },
  19: {
    word: "gedulgt",
    img: Week19Img
  },
  20: {
    word: "knúsa",
    img: Week20Img
  },
  21: {
    word: "ingenlunde",
    img: Week21Img
  },
  22: {
    word: "kuppelkatar",
    img: Week22Img
  },
  23: {
    word: "hjemmelsmand",
    img: Week23Img
  },
  24: {
    word: "lokum",
    img: Week24Img
  },
  25: {
    word: "sagfører",
    img: Week25Img
  },
  26: {
    word: "luffegås",
    img: Week26Img
  },
  27: {
    word: "slev",
    img: Week27Img
  },
  28: {
    word: "skruk",
    img: Week28Img
  },
  29: {
    word: "snurrepiberi",
    img: Week29Img
  },
  30: {
    word: "miskmask",
    img: Week30Img
  },
  31: {
    word: "sporenstregs",
    img: Week31Img
  },
  32: {
    word: "pyjamas",
    img: Week32Img
  },
  33: {
    word: "svirebror",
    img: Week33Img
  },
  34: {
    word: "bums",
    img: Week34Img
  },
  35: {
    word: "træsk",
    img: Week35Img
  },
  36: {
    word: "dadle",
    img: Week36Img
  },
  37: {
    word: "udyd",
    img: Week37Img
  },
  38: {
    word: "sjuft",
    img: Week38Img
  },
  39: {
    word: "underpermissioner",
    img: Week39Img
  },
  40: {
    word: "skråsikker",
    img: Week40Img
  },
  41: {
    word: "ætling",
    img: Week41Img
  },
  42: {
    word: "skuffedarium",
    img: Week42Img
  },
  43: {
    word: "vidløs",
    img: Week43Img
  },
  44: {
    word: "studenterhavre",
    img: Week44Img
  },
  45: {
    word: "bardus",
    img: Week45Img
  },
  46: {
    word: "tuttifrutti",
    img: Week46Img
  },
  47: {
    word: "bragesnak",
    img: Week47Img
  },
  48: {
    word: "ulvetime",
    img: Week48Img
  },
  49: {
    word: "dorsk",
    img: Week49Img
  },
  50: {
    word: "fattigmann",
    img: Week50Img
  },
  51: {
    word: "yule",
    img: Week51Img
  },
  52: {
    word: "risalamande",
    img: Week52Img
  },
  53: {
    word: "bouillon",
    img: Week53Img
  }
};

const currentWeek = parseInt(format(new Date(), "w"));

const currentWordOfTheWeek = wordOfTheWeekMap[currentWeek as keyof typeof wordOfTheWeekMap];
</script>

<template>
  <img
    :src="currentWordOfTheWeek.img"
    :alt="t('le-word-of-the-week.img-alt', { word: currentWordOfTheWeek.word })"
    loading="lazy"
    class="le-word-of-the-week"
  />
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-word-of-the-week {
  width: 100%;
  height: 100%;
  object-fit: contain;

  #media-breakpoint-up(xl, {
    object-fit: cover;
  });
}
</style>
